import React, { useState } from "react";
import ReactTable from "components/ReactTable/ReactTable";
import { Button } from "reactstrap";
import { useHistory, Link } from "react-router-dom";
import apiService from "services/api";
import { useNotificationContext } from "contexts";
import { CustomAlert, CustomTable } from "components";
import { columns } from "./constants";

const MenuItemTable = ({ data, refetch }) => {
    const history = useHistory();
    const { createNotification } = useNotificationContext();
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const initialState = {
        titleEn: "",
        id: "",
    };

    const [menuItemToDelete, setMenuItemToDelete] = useState(initialState);
    const prompDeleteConfirmationMessage = (menuItem) => {
        setMenuItemToDelete(menuItem);
        setShowDeleteModal(true);
    };
    const hideDeleteModal = () => {
        setShowDeleteModal(false);
        setMenuItemToDelete(initialState);
    };

    const deleteMenuItem = async () => {
        try {
            const data = await apiService.deleteMenuItem(menuItemToDelete.id);
            createNotification({
                type: "success",
                message: `Successfully deleted menu item ${data.deleted}`,
            });
            refetch();
        } catch (error) {
            createNotification({
                type: "danger",
                message: error.message,
            });
        } finally {
            hideDeleteModal();
        }
    };

    const actions = (row) => (
        <div className="actions-right">
            {/* use this button to add a like kind of action */}
            {/* use this button to add a edit kind of action */}
            <Button
                onClick={() => history.push(`/coffee/menu-item/edit/${row.id}`)}
                color="warning"
                size="sm"
                className="btn-icon btn-link edit"
            >
                <i className="fa fa-edit" />
            </Button>{" "}
            <Button
                onClick={() => prompDeleteConfirmationMessage(row)}
                color="danger"
                size="sm"
                className="btn-icon btn-link remove"
            >
                <i className="fa fa-times" />
            </Button>
        </div>
    );

    return (
        <div>
            <CustomAlert
                show={showDeleteModal}
                hideModal={hideDeleteModal}
                submitModal={deleteMenuItem}
                title="Delete Menu Item"
                submitButtonText="Delete"
                description={
                    <>
                        Are you sure you want to remove menu item{" "}
                        <span className="text-danger font-weight-bold">
                            {menuItemToDelete.titleEn}?
                        </span>
                    </>
                }
            />
            <div className="mt-3 mb-5">
                <div className="d-flex mb-2">
                    <Link to={`/coffee/menu-item/new`}>
                        <button type="button" className="btn btn-info">
                            Add new menu item
                        </button>
                    </Link>
                </div>
            </div>
            <CustomTable
                data={data}
                columns={columns}
                actions={actions}
                defaultPageSize={100}
                title="Menu Items"
            />
        </div>
    );
};

export default MenuItemTable;
